import React, {Component} from "react";
import {Form, Select, Input, InputNumber,message, Radio} from 'antd';
import NHFormItem from '../../../common/NHFormItem/index';
import PropTypes from 'prop-types';
import NHSelect from "../../../common/NHSelect";
import NHFetch from '../../../../utils/NHFetch';

const {TextArea} = Input;
const Option = Select.Option;

/**
 * 步骤一配置环节信息
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-14 11:45:13
 * Version: 1.0
 * Modify log:
 */
class FirstStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hjlxTmep:'',
            flag:false,
            num:0,
         }
    }

    componentDidMount(){
        let data  = this.props.initFormData;
        if(data && data.hjlx && data.hjlx == 2){
            this.setState({hjlxTmep : 2});
        }
        if(this.state.num == 0){
            if(data.hjlx == 2 ){
                this.setState({flag:true})
            }
        }
        console.log(data,this.state.flag,this.state.num);
    }

    componentWillReceiveProps(items){
        let number = this.state.num;
        if(this.state.num == 0){
            number+=1;
            if(items.initFormData.hjlx == 2 ){
                this.setState({flag:true})
            }
            this.setState({num:number})
        }
    }

    getDisabledHjdm = (e) => {
        if(e != ""){
            NHFetch("/hjgl/getDisabledHjdm", "GET", { hjdm: e })
            .then(res => {
                if (res && res.data===1) {
                    message.warning("该环节代码已存在，请选择其他环节代码！");
                    this.props.form.setFieldsValue({hjdm:''})
                }
                
            });
        }
    }

    onChange =(e) => {
        console.log(e,this.props);
        this.setState({hjlxTmep : e})
    }

    render() {
        const {form, initFormData} = this.props;
        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'hjmc'} label={'环节名称'} hasFeedback={true} form={form} required={true}
                                 whitespace={true}
                                 pattern={{max: 100, message: "流程名称长度不能超过100字符！"}}
                                initialValue={initFormData.hjmc}>
                        <Input placeholder="请输入环节名称"/>
                    </NHFormItem>
                    <NHFormItem id={'hjlx'} label={'环节类型'} form={form} required={true}
                                initialValue={initFormData.hjlx?initFormData.hjlx:'1'} >
                        <Select placeholder={'请选择环节类型'} onChange={this.onChange}  disabled={this.state.flag ? true:false}>
                            <Option key={'1'}>固定环节</Option>
                            <Option key={'2'}>自定义环节</Option>
                        </Select>
                    </NHFormItem>
                    {
                    this.state.hjlxTmep != 2  && 
                    <NHFormItem id={'hjdm'} label={'环节代码'} form={form} required={true}
                        initialValue={initFormData ? initFormData.hjdm:''} >                       
                        <NHSelect style={{ margin: '-5px 0', width: '100%' }} sign="DMK_YXXT_YXXC_GDHJDM" onChange={this.getDisabledHjdm}/>                               
                    </NHFormItem> 
                    }
                    <NHFormItem id={'hjtp'} label={'环节图片'} form={form} required={true} initialValue={initFormData.hjtp}>
                        <NHSelect sign={'dmk_yxxt_hjtp'}/>
                    </NHFormItem>
                    {/* {
                    (this.state.hjlxTmep == '2' || initFormData.hjlx == '2')  && 
                    <NHFormItem id={'sfzdbl'} label={'是否通过刷身份证进行自动办理'} form={form} initialValue={initFormData.sfzdbl ? initFormData.sfzdbl : "0"}>
                        <Radio.Group>
                            <Radio value={"1"}>是</Radio>
                            <Radio value={"0"}>否</Radio>
                        </Radio.Group>
                    </NHFormItem>
                    }  */}
                    <NHFormItem id={'hjms'} label={'描述'} hasFeedback={true} form={form}
                                pattern={{max: 100, message: "环节描述长度不能超过100字符！"}}
                                initialValue={initFormData.hjms}>
                        <TextArea placeholder="请输入100字以内的环节描述" rows={3}/>
                    </NHFormItem>
                </Form>
            </div>
        )
    }
}

FirstStep.defaultProps = {
    initFormData: {} //初始表单数据
}

FirstStep.propTypes = {
    initFormData: PropTypes.object, //初始表单数据
    onChange: PropTypes.func //表单字段值变化时回调
}

const firstStep = Form.create({onValuesChange(props, values){props.onChange(values);}})(FirstStep);
export default firstStep;


// WEBPACK FOOTER //
// ./components/lcgl/hjgl/edit-form/step-first.js